import '../style/select-CG6wZdDq.css'
import { defineComponent as q, ref as T, useModel as ne, watch as D, nextTick as re, openBlock as p, createBlock as V, unref as s, isRef as de, withCtx as d, createVNode as U, withDirectives as ue, vShow as pe, useCssVars as ce, computed as g, toRef as me, normalizeClass as G, createCommentVNode as P, createElementBlock as E, createElementVNode as K, toDisplayString as H, createTextVNode as j, renderSlot as n, withKeys as fe, withModifiers as Y, toRefs as _, useSlots as x, createSlots as ee, Fragment as te, renderList as le } from "vue";
import { UPDATE_MODEL_VALUE as F, CHANGE_EVENT as J } from "./constant/events.js";
import { useFormItem as X } from "./hooks/useFormItem.js";
import { useInputSize as oe } from "./hooks/useInputSize.js";
import { Button as he } from "./button.js";
import Q from "./icon.js";
import ge from "./popper.js";
import Z from "./spinner.js";
import { BaseSizeEnum as ve } from "./constant/common.js";
import "x-utils";
import "@vueuse/core";
import "lodash-es";
import { useI18n as se } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { useElementId as ye } from "./hooks/useElementId.js";
import { useInputClass as be } from "./hooks/useInputClass.js";
import { useKeyboardNavigation as ze } from "./hooks/useKeyboardNavigation.js";
import $e from "./internalComponents/CrossIcon.js";
import Be from "./internalComponents/InputInfoIcon.js";
import Ce from "./input.js";
import { Checkbox as ke } from "./checkbox.js";
const Se = /* @__PURE__ */ q({
  name: "search-box",
  __name: "search",
  props: {
    modelValue: {},
    isOpen: { type: Boolean }
  },
  setup(I) {
    const B = I, t = T(!1), m = ne(B, "modelValue"), { t: C } = se(), f = () => {
      m.value = "";
    };
    return D(() => B.isOpen, (z) => {
      re(() => {
        t.value = z;
      });
    }), (z, k) => (p(), V(s(Ce), {
      modelValue: s(m),
      "onUpdate:modelValue": k[0] || (k[0] = (y) => de(m) ? m.value = y : null),
      class: "e-select-search",
      size: "sm",
      placeholder: s(C)("select.search"),
      focused: t.value,
      "is-error": !1
    }, {
      prefix: d(() => [
        U(s(Q), {
          icon: "search",
          size: "16",
          color: "--text-tertiary"
        })
      ]),
      suffix: d(() => [
        ue(U(s(Q), {
          icon: "cross-circle-fill",
          size: "16",
          color: "--text-tertiary",
          onClick: f
        }, null, 512), [
          [pe, s(m).length]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "focused"]));
  }
}), Oe = { class: "e-selected" }, we = {
  key: 1,
  class: "e-select-placeholder"
}, Ve = {
  key: 1,
  class: "e-select-selected"
}, Ee = { class: "text-caption2" }, He = ["id", "aria-label"], Ie = {
  key: 0,
  class: "e-select__empty"
}, Re = {
  key: 1,
  class: "e-select__empty"
}, ae = /* @__PURE__ */ q({
  __name: "wrapper",
  props: {
    selectedOptions: {},
    multiple: { type: Boolean },
    wrapperHeight: {},
    options: { default: () => [] },
    size: { default: ve.Medium },
    disabled: { type: Boolean },
    filterable: { type: Boolean },
    filterProp: { default: "text" },
    clearable: { type: Boolean },
    loading: { type: Boolean },
    optionsLoading: { type: Boolean },
    placeholder: {},
    name: {},
    placement: { default: "bottom-start" },
    isError: { type: Boolean, default: void 0 },
    selectHeight: {},
    selectItemHeight: {},
    autoContentWidth: { type: Boolean, default: !1 },
    triggerStyle: {},
    theme: {},
    lazy: { type: Boolean },
    teleported: { type: Boolean, default: !0 },
    alignRight: { type: Boolean },
    focused: { type: Boolean }
  },
  emits: ["clear", "open"],
  setup(I, { emit: B }) {
    ce((l) => ({
      "42587d5c": l.wrapperHeight,
      "6604bf34": N.value
    }));
    const t = I, m = B, { elementId: C } = ye("select-listbox"), { t: f } = se(), z = g(() => ({
      size: t.size,
      optionsLoading: t.optionsLoading,
      clearable: t.clearable,
      error: M.value,
      autoWidth: t.autoContentWidth,
      theme: t.theme,
      excludeBaseClass: !0,
      focus: h.value || t.focused
    })), { inputClass: k } = be(t.multiple ? "multi-select" : "select", z), { formItem: y } = X(), h = T(!1), b = T(""), i = T(), { focusIndex: S } = ze({
      watchSource: h,
      wrapperRef: i
    }), R = g(() => t.filterable && !t.optionsLoading), M = g(() => t.isError ?? y.isError), N = g(() => t.selectItemHeight ?? t.wrapperHeight), o = g(() => `--select-item-height: ${N.value}`), O = g(() => t.autoContentWidth ? ["minWidth"] : ["sameWidth"]), c = (l) => {
      const e = [];
      return Array.isArray(t.filterProp) ? e.push(...t.filterProp.map((a) => l[a].toLowerCase())) : e.push(l[t.filterProp].toLowerCase()), e;
    }, $ = g(() => {
      const l = b.value.toLowerCase();
      if (t.filterable) {
        const e = t.options.map((r) => {
          const L = c(r);
          return {
            ...r,
            _included: L.some((A) => A.includes(l)),
            _startsWith: L.some((A) => A.startsWith(l))
          };
        }), a = [], u = e.filter((r) => {
          const { _included: L, _startsWith: A, ...ie } = r;
          return r._startsWith && a.push(ie), !r._startsWith && r._included;
        });
        return a.concat(u);
      } else
        return t.options;
    });
    D(h, (l) => {
      l && m("open");
    });
    const v = me(t, "disabled");
    function w() {
      m("clear");
    }
    function W(l = !t.multiple) {
      l && (h.value = !1);
    }
    return (l, e) => (p(), V(s(ge), {
      id: s(y).formItemId,
      modelValue: h.value,
      "onUpdate:modelValue": e[3] || (e[3] = (a) => h.value = a),
      class: G(s(k)),
      placement: l.placement,
      variant: "select",
      transition: "slide",
      "offset-distance": 0,
      disabled: v.value,
      lazy: l.lazy,
      size: l.size,
      teleported: l.teleported,
      "toggle-by-click": !0,
      "trigger-by-hover": !1,
      "trigger-style": l.triggerStyle,
      "disable-click-away": !1,
      "content-style": o.value,
      modifiers: O.value,
      "trigger-attributes": {
        "aria-controls": s(C),
        "aria-expanded": h.value,
        "aria-haspopup": "listbox",
        "aria-label": s(y).label ?? "Select",
        role: "combobox",
        tabindex: "0"
      },
      theme: l.theme
    }, {
      content: d(() => [
        R.value ? (p(), V(Se, {
          key: 0,
          modelValue: b.value,
          "onUpdate:modelValue": e[0] || (e[0] = (a) => b.value = a),
          "is-open": h.value
        }, null, 8, ["modelValue", "is-open"])) : P("", !0),
        R.value && l.multiple ? (p(), E("div", Ve, [
          K("span", Ee, H(s(f)("select.pagination", { n: l.selectedOptions.length, total: l.options.length })), 1),
          U(s(he), {
            size: "sm",
            text: "",
            onClick: w
          }, {
            default: d(() => [
              j(H(s(f)("select.clear")), 1)
            ]),
            _: 1
          })
        ])) : P("", !0),
        n(l.$slots, "header"),
        K("ul", {
          id: s(C),
          ref_key: "listboxRef",
          ref: i,
          role: "listbox",
          "aria-label": s(y).label,
          tabindex: "-1",
          class: "e-select-options e-scroller",
          onClick: e[1] || (e[1] = (a) => W()),
          onKeydown: e[2] || (e[2] = fe(Y((a) => W(), ["stop", "prevent"]), ["enter"]))
        }, [
          !$.value.length && !l.optionsLoading ? (p(), E("li", Ie, [
            n(l.$slots, "no-option", {}, () => [
              j(H(s(f)("select.noOptions")), 1)
            ])
          ])) : P("", !0),
          l.optionsLoading ? (p(), E("li", Re, [
            U(s(Z))
          ])) : P("", !0),
          n(l.$slots, "options", {
            filteredOptions: $.value,
            focusIndex: s(S)
          }),
          n(l.$slots, "last-option")
        ], 40, He),
        n(l.$slots, "footer", { closePopper: W })
      ]),
      default: d(() => [
        n(l.$slots, "prefix"),
        K("div", Oe, [
          K("div", {
            class: G(["e-selected-value", { "e-selected-value--right": l.alignRight }])
          }, [
            l.selectedOptions.length > 0 ? n(l.$slots, "selected", {
              key: 0,
              selected: l.selectedOptions
            }) : (p(), E("span", we, H(l.placeholder || s(f)("select.placeholder")), 1))
          ], 2),
          l.clearable && (l.multiple ? l.selectedOptions.length > 0 : l.selectedOptions[0]) && !v.value ? (p(), V($e, {
            key: 0,
            size: l.size,
            onClick: Y(w, ["stop"])
          }, null, 8, ["size"])) : P("", !0),
          l.loading ? (p(), V(s(Z), {
            key: 1,
            color: "--text-primary",
            size: "20"
          })) : P("", !0),
          U(s(Q), {
            icon: "caret-down",
            rotation: h.value ? 180 : 0,
            size: "20"
          }, null, 8, ["rotation"]),
          n(l.$slots, "suffix"),
          M.value ? (p(), V(Be, {
            key: 2,
            "is-error": "",
            class: "e-select__error-icon"
          })) : P("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "modelValue", "class", "placement", "disabled", "lazy", "size", "teleported", "trigger-style", "content-style", "modifiers", "trigger-attributes", "theme"]));
  }
}), We = ["title", "aria-selected", "onClick"], Le = { class: "e-select-item__text" }, dt = /* @__PURE__ */ q({
  name: "e-select",
  __name: "select",
  props: {
    modelValue: {},
    options: { default: () => [] },
    size: {},
    disabled: { type: Boolean },
    filterable: { type: Boolean },
    filterProp: { default: "text" },
    clearable: { type: Boolean },
    loading: { type: Boolean },
    optionsLoading: { type: Boolean },
    placeholder: {},
    name: {},
    placement: { default: "bottom-start" },
    isError: { type: Boolean, default: void 0 },
    selectHeight: {},
    selectItemHeight: {},
    autoContentWidth: { type: Boolean },
    triggerStyle: {},
    theme: {},
    lazy: { type: Boolean, default: !0 },
    teleported: { type: Boolean, default: !0 },
    alignRight: { type: Boolean },
    focused: { type: Boolean }
  },
  emits: [F, J],
  setup(I, { emit: B }) {
    const t = I, { disabled: m, size: C } = _(t), f = x(), { formSize: z } = X(), { actualSize: k, height: y } = oe({ formSize: z, propSize: C }), h = g(() => t.selectHeight ?? y.value), b = B, i = T([]);
    let S = !1;
    D(() => t.options, () => {
      R(t.modelValue);
    }), D(() => t.modelValue, (o) => {
      R(o);
    }, { immediate: !0 });
    function R(o) {
      if (S) {
        S = !1;
        return;
      }
      i.value = t.options.filter((O) => O.value === o);
    }
    function M(o, O) {
      if (o.disabled) {
        O.stopPropagation();
        return;
      }
      if (i.value[0]?.value !== o.value) {
        i.value = t.options.filter(($) => $.value === o.value), S = !0;
        const c = i.value[0].value ?? "";
        b(F, c), b(J, c);
      }
    }
    function N() {
      i.value = [], b(F, ""), b(J, "");
    }
    return (o, O) => (p(), V(ae, {
      options: o.options,
      size: s(k),
      disabled: s(m),
      filterable: o.filterable,
      "filter-prop": o.filterProp,
      clearable: o.clearable,
      loading: o.loading,
      "options-loading": o.optionsLoading,
      placeholder: o.placeholder,
      placement: o.placement,
      "selected-options": i.value,
      "auto-content-width": o.autoContentWidth,
      "wrapper-height": h.value,
      "select-item-height": o.selectItemHeight,
      "trigger-style": o.triggerStyle,
      theme: o.theme,
      lazy: o.lazy,
      focused: o.focused,
      teleported: o.teleported,
      "is-error": o.isError,
      "align-right": o.alignRight,
      onClear: N
    }, ee({
      selected: d(({ selected: c }) => [
        n(o.$slots, "selected", {
          selected: c[0]
        }, () => [
          j(H(c[0].text), 1)
        ])
      ]),
      options: d(({ filteredOptions: c, focusIndex: $ }) => [
        (p(!0), E(te, null, le(c, (v, w) => (p(), E("li", {
          key: `option-${w}`,
          title: v.text,
          class: G(["e-select-item", {
            selected: v.value === i.value[0]?.value,
            focused: w === $,
            disabled: v.disabled
          }]),
          role: "option",
          tabindex: "-1",
          "aria-selected": v.value === i.value[0]?.value,
          onClick: (W) => M(v, W)
        }, [
          n(o.$slots, "default", { option: v }, () => [
            K("span", Le, H(v.text), 1)
          ])
        ], 10, We))), 128))
      ]),
      prefix: d(() => [
        n(o.$slots, "prefix")
      ]),
      suffix: d(() => [
        n(o.$slots, "suffix")
      ]),
      "no-option": d(() => [
        n(o.$slots, "no-option")
      ]),
      _: 2
    }, [
      s(f)["last-option"] ? {
        name: "last-option",
        fn: d(() => [
          n(o.$slots, "last-option")
        ]),
        key: "0"
      } : void 0,
      s(f).header ? {
        name: "header",
        fn: d(() => [
          n(o.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      s(f).footer ? {
        name: "footer",
        fn: d(({ closePopper: c }) => [
          n(o.$slots, "footer", { closePopper: c })
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["options", "size", "disabled", "filterable", "filter-prop", "clearable", "loading", "options-loading", "placeholder", "placement", "selected-options", "auto-content-width", "wrapper-height", "select-item-height", "trigger-style", "theme", "lazy", "focused", "teleported", "is-error", "align-right"]));
  }
}), Pe = ["title", "aria-selected"], ut = /* @__PURE__ */ q({
  name: "e-multi-select",
  __name: "multi-select",
  props: {
    modelValue: {},
    max: {},
    options: { default: () => [] },
    size: {},
    disabled: { type: Boolean },
    filterable: { type: Boolean },
    filterProp: { default: "text" },
    clearable: { type: Boolean },
    loading: { type: Boolean },
    optionsLoading: { type: Boolean },
    placeholder: {},
    name: {},
    placement: { default: "bottom-start" },
    isError: { type: Boolean, default: void 0 },
    selectHeight: {},
    selectItemHeight: {},
    autoContentWidth: { type: Boolean },
    triggerStyle: {},
    theme: {},
    lazy: { type: Boolean, default: !0 },
    teleported: { type: Boolean, default: !0 },
    alignRight: { type: Boolean },
    focused: { type: Boolean }
  },
  emits: [F, "open"],
  setup(I, { emit: B }) {
    const t = I, m = B, { disabled: C, size: f } = _(t), z = x(), { formSize: k } = X(), { actualSize: y, height: h } = oe({ formSize: k, propSize: f }), b = g(() => t.selectHeight ?? h.value), i = T([]), S = g(() => i.value.length >= Number(t.max)), R = g(() => i.value.map((e) => t.options.find((u) => u.value === e)).filter((e) => !!e)), M = g(() => t.options.map((e) => ({
      ...e,
      selected: i.value.includes(e.value) || !!e.selected
    }))), N = g(() => {
      const e = i.value.reduce((a, u) => {
        const r = t.options.find((L) => L.value === u);
        return a.push(...r?.relatedOptions || []), a;
      }, []);
      return [...new Set(e)];
    });
    D(() => t.options, () => {
      i.value = t.modelValue;
    }), D(() => t.modelValue, (e) => {
      i.value = e;
    }, { immediate: !0 });
    function o(e) {
      return (e.relatedOptions?.filter((u) => !i.value.includes(u)) || []).length;
    }
    function O(e) {
      const a = o(e);
      return i.value.length + a + 1 > (t.max || 0);
    }
    function c(e) {
      return N.value.includes(e.value);
    }
    function $(e) {
      const a = e.disabled || !e.selected && S.value, u = t.max && O(e);
      return !!(a || u || c(e));
    }
    function v(e) {
      if (!e.disabled) {
        if (i.value.includes(e.value)) {
          if (c(e))
            return;
          i.value = i.value.filter((a) => a !== e.value), w("remove", e);
        } else {
          if ($(e))
            return;
          if (!S.value) {
            const a = [e.value];
            a.push(...w("add", e)), i.value = [.../* @__PURE__ */ new Set([...i.value, ...a])];
          }
        }
        l();
      }
    }
    function w(e, a) {
      return e === "add" ? a.relatedOptions || [] : (i.value = i.value.filter((u) => !a.relatedOptions?.includes(u)), []);
    }
    function W() {
      i.value = [], l();
    }
    function l() {
      m(F, i.value);
    }
    return (e, a) => (p(), V(ae, {
      "data-multiselectable": "true",
      options: M.value,
      size: s(y),
      disabled: s(C),
      filterable: e.filterable,
      "filter-prop": e.filterProp,
      clearable: e.clearable,
      loading: e.loading,
      "options-loading": e.optionsLoading,
      placeholder: e.placeholder,
      placement: e.placement,
      "is-error": e.isError,
      "selected-options": R.value,
      "auto-content-width": e.autoContentWidth,
      "wrapper-height": b.value,
      "select-item-height": e.selectItemHeight,
      "trigger-style": e.triggerStyle,
      theme: e.theme,
      lazy: e.lazy,
      focused: e.focused,
      teleported: e.teleported,
      "align-right": e.alignRight,
      multiple: "",
      onOpen: a[0] || (a[0] = (u) => m("open")),
      onClear: W
    }, ee({
      selected: d(({ selected: u }) => [
        n(e.$slots, "selected", { selected: u }, () => [
          j(H(u.map((r) => r.text).join(",")), 1)
        ])
      ]),
      options: d(({ filteredOptions: u }) => [
        (p(!0), E(te, null, le(u, (r, L) => (p(), E("li", {
          key: `option-${L}`,
          title: r.text,
          class: G(["e-select-item", { focus: r.selected }]),
          role: "option",
          tabindex: "-1",
          "aria-selected": r.selected
        }, [
          U(s(ke), {
            "model-value": r.selected,
            class: "e-select-item__checkbox",
            size: s(f),
            disabled: $(r),
            onClick: (A) => v(r)
          }, {
            default: d(() => [
              n(e.$slots, "default", {
                option: r,
                selected: r.selected
              }, () => [
                j(H(r.text), 1)
              ])
            ]),
            _: 2
          }, 1032, ["model-value", "size", "disabled", "onClick"])
        ], 10, Pe))), 128))
      ]),
      prefix: d(() => [
        n(e.$slots, "prefix")
      ]),
      suffix: d(() => [
        n(e.$slots, "suffix")
      ]),
      "no-option": d(() => [
        n(e.$slots, "no-option")
      ]),
      _: 2
    }, [
      s(z)["last-option"] ? {
        name: "last-option",
        fn: d(() => [
          n(e.$slots, "last-option")
        ]),
        key: "0"
      } : void 0,
      s(z).footer ? {
        name: "footer",
        fn: d(({ closePopper: u }) => [
          n(e.$slots, "footer", { closePopper: u })
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["options", "size", "disabled", "filterable", "filter-prop", "clearable", "loading", "options-loading", "placeholder", "placement", "is-error", "selected-options", "auto-content-width", "wrapper-height", "select-item-height", "trigger-style", "theme", "lazy", "focused", "teleported", "align-right"]));
  }
});
export {
  ut as MultiSelect,
  dt as Select
};
//# sourceMappingURL=select.js.map
